import { useAccount, useBalance, useReadContract } from 'wagmi'

import useTokenggAVAXContract from './contracts/tokenggAVAX'

import { WAVAX_ADDR } from '@/constants/contractAddresses'
import { useValueTokens } from '@/contexts/VaultTokensContext'
import seaAVAX from '@/contracts/seaAVAX'
import xGGP from '@/contracts/xGGP'

function useAvaxBalanceOfggAvax() {
  const { address: ggAVAXAddress } = useTokenggAVAXContract()
  const balance = useBalance({
    address: ggAVAXAddress as `0x${string}`,
    token: WAVAX_ADDR,
  })
  return balance
}

export function useAvaliableForStaking() {
  const { abi, address: ggAVAXAddress } = useTokenggAVAXContract()

  return useReadContract({
    address: ggAVAXAddress as `0x${string}`,
    abi: abi,
    functionName: 'amountAvailableForStaking',
  })
}

export function useMaxRedeem() {
  const { currentToken } = useValueTokens()
  const { address, chain } = useAccount()
  const addr = currentToken.tokenAddresses[1][chain?.id]

  return useReadContract({
    address: addr as `0x${string}`,
    abi: currentToken.displayName === 'GGP' ? xGGP : seaAVAX,
    functionName: 'maxRedeem',
    args: [address],
  })
}

export function useMaxWithdraw() {
  const { currentToken } = useValueTokens()
  const { address, chain } = useAccount()
  const addr = currentToken.tokenAddresses[1][chain?.id]

  return useReadContract({
    address: addr as `0x${string}`,
    abi: currentToken.displayName === 'GGP' ? xGGP : seaAVAX,
    functionName: 'maxWithdraw',
    args: [address],
  })
}

export function useMaxDeposit() {
  const { currentToken } = useValueTokens()
  const { address, chain } = useAccount()
  const addr = currentToken.tokenAddresses[1][chain?.id]

  return useReadContract({
    address: addr as `0x${string}`,
    abi: currentToken.displayName === 'GGP' ? xGGP : seaAVAX,
    functionName: 'maxDeposit',
    args: [address],
  })
}

export function usePreviewWithdraw(amount: bigint, enabled = true) {
  const { currentToken } = useValueTokens()
  const { chain } = useAccount()
  const addr = currentToken.tokenAddresses[1][chain?.id]

  return useReadContract({
    address: addr as `0x${string}`,
    abi: currentToken.displayName === 'GGP' ? xGGP : seaAVAX,
    functionName: 'previewWithdraw',
    args: [amount],
    query: {
      enabled,
    },
  })
}

export function usePreviewReedem(shares: bigint, enabled = true) {
  const { currentToken } = useValueTokens()
  const { chain } = useAccount()
  const addr = currentToken.tokenAddresses[1][chain?.id]

  return useReadContract({
    address: addr as `0x${string}`,
    abi: currentToken.displayName === 'GGP' ? xGGP : seaAVAX,
    functionName: 'previewRedeem',
    args: [shares],
    query: {
      enabled,
    },
  })
}

export function useConvertToAssets(shares: bigint) {
  const { currentToken } = useValueTokens()
  const { chain } = useAccount()
  const addr = currentToken.tokenAddresses[1][chain?.id]

  return useReadContract({
    address: addr as `0x${string}`,
    abi: currentToken.displayName === 'GGP' ? xGGP : seaAVAX,
    functionName: 'convertToAssets',
    args: [shares],
  })
}

export function useConvertToShares(assets: bigint) {
  const { currentToken } = useValueTokens()
  const { chain } = useAccount()
  const addr = currentToken.tokenAddresses[1][chain?.id]

  return useReadContract({
    address: addr as `0x${string}`,
    abi: currentToken.displayName === 'GGP' ? xGGP : seaAVAX,
    functionName: 'convertToShares',
    args: [assets],
  })
}

export function useBalanceOf() {
  const { currentToken } = useValueTokens()
  const { address, chain } = useAccount()
  const addr = currentToken.tokenAddresses[1][chain?.id]

  return useReadContract({
    address: addr as `0x${string}`,
    abi: currentToken.displayName === 'GGP' ? xGGP : seaAVAX,
    functionName: 'balanceOf',
    args: [address],
  })
}

export default useAvaxBalanceOfggAvax
